import { render, staticRenderFns } from "./LinkRoundedIcon.vue?vue&type=template&id=6a4bd43f&scoped=true"
import script from "./LinkRoundedIcon.vue?vue&type=script&lang=js"
export * from "./LinkRoundedIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4bd43f",
  null
  
)

export default component.exports